const LOG_TABS = {
	SALES: 'sales',
	PURCHASES: 'purchases',
	GENERAL: 'general'
};

export default LOG_TABS;
